import { Injectable } from '@angular/core';

import { ISlip } from '../../../../../bet-generation/models';
import { OddsBoostToken } from '../../../../../reward-tokens/reward-tokens.model';
import { RewardTokensMaxStakeError } from '../../../../errors/general/reward-tokens-max-stake-error';
import { SlipValidationContext } from '../../../../models/models';
import type { IContextSlipValidator } from '../validators';

@Injectable()
export class RewardTokensMaxStakeValidator implements IContextSlipValidator<RewardTokensMaxStakeError> {
    validate(_: ISlip, { rewardTokens }: SlipValidationContext): RewardTokensMaxStakeError[] {
        const selectedToken = rewardTokens.selectedToken;

        if (!selectedToken || !rewardTokens.errors.maximumStake) {
            return [];
        }

        const selectedOddsBoostToken = <OddsBoostToken>selectedToken;

        return [new RewardTokensMaxStakeError(selectedOddsBoostToken.maximumStake!)];
    }
}
